const getConfig = () => {
  // Force dev/production environment if REACT_APP_ENV is 'dev' or not set
  const env = (process.env.REACT_APP_ENV || 'dev').toLowerCase();

  const configEnv =
    env === 'staging' || env === 'stage'
      ? 'staging'
      : 'dev'; // Default to 'dev' for production

  const environment = {
    dev: {
      LAMBDA_URL: {
        // Production (dev) API URLs - exactly as they were working before
        // These are the original production URLs that must work correctly
        CATALOG_PRODUCTS: process.env.REACT_APP_CATALOG_PRODUCTS_URL || 'https://wa5b4clkj5wlqp6k7izdv6enty0ioomi.lambda-url.us-east-1.on.aws',
        PROPERTY_SHEET: process.env.REACT_APP_PROPERTY_SHEET_URL || 'https://xbyzl371xd.execute-api.us-east-1.amazonaws.com/dev',
        IMAGE_SEARCH: process.env.REACT_APP_IMAGE_SEARCH_URL || 'https://3wubou0d27.execute-api.us-east-1.amazonaws.com/default/product_level_search',
        USER_MANAGEMENT: process.env.REACT_APP_USER_MANAGEMENT_URL || 'https://ix9ulsrlg5.execute-api.us-east-1.amazonaws.com/dev',
        PRODUCTS: process.env.REACT_APP_PRODUCTS_URL || 'https://9jzvgul0kj.execute-api.us-east-1.amazonaws.com/dev'
      },
      BASE_URL: process.env.REACT_APP_BASE_URL || 'https://api.reverie3d.com',
      // External APIs (same for both dev and staging)
      EXTERNAL_APIS: {
        TAX_API: process.env.REACT_APP_TAX_API_URL || 'https://api.api-ninjas.com/v1'
      },
      ENVIRONMENT: 'production'
    },
    staging: {
      LAMBDA_URL: {
        CATALOG_PRODUCTS: process.env.REACT_APP_CATALOG_PRODUCTS_URL || 'https://ptuaqmr4mtr4bbuldn47xb23ly0gmlis.lambda-url.us-east-1.on.aws',
        PROPERTY_SHEET: process.env.REACT_APP_PROPERTY_SHEET_URL || 'https://6y66o71zuh.execute-api.us-east-1.amazonaws.com/staging',
        IMAGE_SEARCH: process.env.REACT_APP_IMAGE_SEARCH_URL || 'https://c2v1iipzmh.execute-api.us-east-1.amazonaws.com/default/product_level_search',
        USER_MANAGEMENT: process.env.REACT_APP_USER_MANAGEMENT_URL || 'https://35zyox5pfj.execute-api.us-east-1.amazonaws.com/staging',
        PRODUCTS: process.env.REACT_APP_PRODUCTS_URL || 'https://bjjfbg5kvd.execute-api.us-east-1.amazonaws.com/staging'
      },
      BASE_URL: process.env.REACT_APP_BASE_URL || 'https://staging-api.reverie3d.com',
      // External APIs (same for both dev and staging)
      EXTERNAL_APIS: {
        TAX_API: process.env.REACT_APP_TAX_API_URL || 'https://api.api-ninjas.com/v1'
      },
      ENVIRONMENT: 'staging'
    }
  };

  let amplify;
  try {
    switch (configEnv) {
      case 'staging':
        // eslint-disable-next-line global-require
        amplify = require('./amplifyconfiguration.staging.json');
        break;
      default:
        // eslint-disable-next-line global-require
        amplify = require('./amplifyconfiguration.dev.json');
        break;
    }
  } catch (error) {
    // Fallback to dev config if anything goes wrong
    // eslint-disable-next-line global-require
    amplify = require('./amplifyconfiguration.dev.json');
  }

  // Always fallback to dev if configEnv is invalid
  const selectedEnv = environment[configEnv] || environment.dev;
  
  return {
    env: selectedEnv,
    amplify
  };
};

const config = getConfig();

export const environmentConfig = config.env;
export const amplifyConfig = config.amplify;
export default config;


